import React, { useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Grid,
    Link,
    colors
} from '@material-ui/core';

import { PluginContext } from '../contexts/PluginContext';

import { makeStyles, withStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    }
}));

export const PageFooter = ({ ...props }) => {
    const classes = useStyles();

    const {
        plugin
    } = useContext(PluginContext);

    return (
        <Grid
            container
            alignItems="center"
            justify="center"
            className={clsx(classes.root, props.className)}>
            <Grid item style={{ marginTop: 32 }}>
                Version <strong>{plugin.pluginVersion}</strong> Copyright 2024 by <Link href="https://teamonair.com/">Teamonair.com</Link>
            </Grid>
        </Grid>
    )
}